export const filterPinoMessage = pinoMessage => {
  const {
    pid,
    hostname,
    ...otherProperties
  } = pinoMessage;
  return otherProperties;
};
//# sourceMappingURL=filterPinoMessage.js.map